import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface EssayImageState {
  isLoading: boolean;
  isSuccess: boolean;
  imageURL: string | null;
  setIsLoading: (loading: boolean) => void;
  setIsSuccess: (status: boolean) => void;
  setImageURL: (url: string | null) => void;
  resetEssayImage: () => void;
}

export const useEssayImageStore = create<EssayImageState>()(
  persist(
    (set) => ({
      isLoading: false,
      isSuccess: false,
      imageURL: null,
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setIsSuccess: (status: boolean) => set({ isSuccess: status }),
      setImageURL: (url: string | null) => set({ imageURL: url }),
      resetEssayImage: () => set({
        isLoading: false,
        isSuccess: false,
        imageURL: null,
      })
    }),
    {
      name: 'essay-image'
    }
  )
);
